var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64,0a64,64,0,1,0,64,64A64,64,0,0,0,64,0Zm1.33,92a27.88,27.88,0,0,0,19.3-7.71l2.9-2.76L93,87.33l-2.9,2.76a36,36,0,1,1,.34-51.83L93.35,41l-5.59,5.72L84.9,44A28,28,0,1,0,65.33,92Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyright);
export default __webpack_public_path__ + "static/media/copyright.0c48f8596aa0675785762076b32a2954.svg";
export { ForwardRef as ReactComponent };